import { render, staticRenderFns } from "./squareColor.vue?vue&type=template&id=4d9d6674&scoped=true&"
import script from "./squareColor.vue?vue&type=script&lang=js&"
export * from "./squareColor.vue?vue&type=script&lang=js&"
import style0 from "./squareColor.vue?vue&type=style&index=0&id=4d9d6674&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9d6674",
  null
  
)

export default component.exports